var React = require('react');

function Triangle2FormMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-74 86.1416L38.2701 153.141M-74 86.1416L3.68973 83.9958M-74 86.1416L52.0145 49.1817M38.2701 153.141L3.68973 83.9958M38.2701 153.141L52.0145 49.1817M3.68973 83.9958L52.0145 49.1817","stroke":"#DADADA"}));
}

Triangle2FormMobile.defaultProps = {"width":"95","height":"165","viewBox":"0 0 95 165","fill":"none"};

module.exports = Triangle2FormMobile;

Triangle2FormMobile.default = Triangle2FormMobile;
